export default __webpack_public_path__ + "static/media/img3.3a8eaab3.png";